import { useI18n } from 'hooks/useI18n';
import { UIOfferWhenSection } from 'interfaces/ui/ui-offer-when-section';
import JobOfferLongText from '../JobOfferLongText';
import JobOfferSection from '../JobOfferSection';
import JobOfferSubsection from '../JobOfferSubsection';
import WhenHighlights from './WhenHighlights';
import WhenSchedule from './WhenSchedule';
import { StyledWhenSection } from './WhenSection.styled';
import WhenWatch from './WhenWatch';

const WhenSection = ({
  whenIntro,
  highlightsIntro,
  highlights,
  schedules,
  watchIntro,
  watchFaqs,
  migratedToMarkdown,
  isFreelance
}: UIOfferWhenSection) => {
  const { t } = useI18n('job-offer');
  const showHighlights = highlights && highlights.length > 0;
  const showSchedules = schedules && schedules.length > 0;
  const showSection = showHighlights || showSchedules;

  return (
    <JobOfferSection
      name="horario"
      sectionBg="alt"
      title={t(isFreelance ? 'titles.schedule_freelance' : 'titles.schedule')}
    >
      <JobOfferLongText isMarkdown={migratedToMarkdown}>
        {whenIntro}
      </JobOfferLongText>

      {showSection && !isFreelance && (
        <StyledWhenSection>
          {showHighlights && (
            <WhenHighlights
              migratedToMarkdown={migratedToMarkdown}
              highlightsIntro={highlightsIntro}
              highlights={highlights}
              isFreelance={isFreelance}
            />
          )}

          {showSchedules && (
            <JobOfferSubsection title={t('when.schedule')}>
              <WhenSchedule
                schedules={schedules}
                migratedToMarkdown={migratedToMarkdown}
              />
            </JobOfferSubsection>
          )}

          {((watchFaqs && watchFaqs.length > 0) || watchIntro) && (
            <WhenWatch
              watchIntro={watchIntro}
              watchFaqs={watchFaqs}
              migratedToMarkdown={migratedToMarkdown}
              isFreelance={isFreelance}
            />
          )}
        </StyledWhenSection>
      )}
    </JobOfferSection>
  );
};

export default WhenSection;
